module.exports = __webpack_public_path__ + "static/media/copyIcon.8af782e3.svg";